import React from 'react';
import { Play } from 'lucide-react';

const ReplayBadge = ({ text }) => {
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-indigo-400 text-indigo-600 text-xs font-medium bg-white">
      <Play className="w-2.5 h-2.5 fill-indigo-600 text-indigo-600" />
      {text}
    </span>
  );
};

export default ReplayBadge;
